import { render, staticRenderFns } from "./Started.vue?vue&type=template&id=dc9fe304&scoped=true"
import script from "./Started.vue?vue&type=script&lang=js"
export * from "./Started.vue?vue&type=script&lang=js"
import style0 from "./Started.vue?vue&type=style&index=0&id=dc9fe304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9fe304",
  null
  
)

export default component.exports